
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation('services');

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/961d288b4cc092745d1600bc994b31a8.jpg')`
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0D1B2A]/90 via-[#0D1B2A]/70 to-transparent" />
      
      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="w-full h-full" style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }} />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl lg:text-7xl font-thin mb-8 leading-tight">
            <span className="text-white block mb-2">Services</span>
            <span className="text-[#2E8BC0] font-bold block">BULKCOM</span>
          </h1>
          
          <p className="text-xl lg:text-2xl text-white/90 font-thin tracking-wide leading-relaxed uppercase">
            {t('hero.description', 'COMPREHENSIVE ENERGY SOLUTIONS FOR GAS, ELECTRICITY AND BUSINESS CONSULTING SERVICES')}
          </p>
        </div>
      </div>
    </section>
  );
}
